var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 0.835938C4.96094 0.835938 0.835938 4.96094 0.835938 10.0026C0.835938 15.0443 4.96094 19.1693 10.0026 19.1693C15.0443 19.1693 19.1693 15.0443 19.1693 10.0026C19.1693 4.96094 15.0443 0.835938 10.0026 0.835938ZM10.0026 17.3359C5.9601 17.3359 2.66927 14.0451 2.66927 10.0026C2.66927 5.9601 5.9601 2.66927 10.0026 2.66927C14.0451 2.66927 17.3359 5.9601 17.3359 10.0026C17.3359 14.0451 14.0451 17.3359 10.0026 17.3359ZM14.2101 5.95094L8.16927 11.9918L5.7951 9.62677L4.5026 10.9193L8.16927 14.5859L15.5026 7.2526L14.2101 5.95094Z",
    fill: "#008000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.a259989d7db8b2c75b41797438cbad86.svg";
export { ForwardRef as ReactComponent };